import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { targetObjectTypeOrder } from '@sidebar/SearchItems';
import { useInitiativeReference } from './useInitiativeReference';
import { useMemo } from 'react';

export type ScopeCounts = [SonarObjectType, number][];

const [ objectType, fieldType, ...allOtherTypes ] = targetObjectTypeOrder;

export const scopeOrder = [ fieldType, objectType, SonarObjectType.SalesforcePicklistValue, ...allOtherTypes ];

export interface UseInitiativeScopeCountsResult {
	counts: ScopeCounts;
	totalCount: number;
}

export function useInitiativeScopeCounts(initiativeId: number): UseInitiativeScopeCountsResult {
	const counts = useInitiativeReference(initiativeId).scopeCounts;

	const [ totalCount, scopeCounts ] = useMemo<[number, ScopeCounts]>(() => {
		let total = 0;
		const typeCounts: ScopeCounts = [];

		for (const typeEntry of scopeOrder) {
			const count = counts[ typeEntry ] ?? 0;

			if (count) {
				total += count;
				typeCounts.push([ typeEntry, count ]);
			}
		}

		return [ total, typeCounts ];
	}, [ counts ]);

	return {
		counts: scopeCounts,
		totalCount
	};
}
